<template>
  <div>
    <el-form
      ref="form"
      size="small"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
    >
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item
              :label="$l('form_label_attribute_type') || '属性类型'"
              prop="deAttributeType"
            >
              <el-input
                :disabled="deAttributeTypeCode!=''"
                v-model="formData.deAttributeType"
                maxlength="50"
                clearable
                size="medium"
                :placeholder="$l('form_label_attribute_type') || '属性类型'"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
              :label="$l('form_label_name_cn') || '中文名称'"
              prop="deAttributeTypeName"
            >
              <el-input
                v-model="formData.deAttributeTypeName"
                maxlength="100"
                clearable
                size="medium"
                :placeholder="$l('form_label_name_cn') || '中文名称'"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
              :label="$l('form_label_name_en') || '英文名称'"
              prop="deAttributeTypeNameEn"
            >
              <el-input
                v-model="formData.deAttributeTypeNameEn"
                maxlength="100"
                clearable
                size="medium"
                :placeholder="$l('form_label_name_en') || '英文名称'"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    disabled: Boolean,
    deAttributeTypeCode: String,
    params: { type: Object, default: () => {} }
  },
  data() {
    return {
      formData: { deAttributeType: '', deAttributeTypeName: '',deAttributeTypeNameEn: '' },
      rules: {
        deAttributeType: [
          {
            required: true,
            message:
              this.$l('form_rule_message_attribute_type') || '请输入属性类型',
            trigger: 'blur',
          },
          {
            max: 50,
            message:
              this.$l('form_rule_input_length_50') || '长度在50个字符以内',
            trigger: 'blur',
          },
        ],
        deAttributeTypeName: [
          {
            required: true,
            message: this.$l('form_rule_message_name_cn') || '请输入中文名称',
            trigger: 'blur',
          },
          {
            max: 100,
            message:
              this.$l('form_rule_input_length_100') || '长度在100个字符以内',
            trigger: 'blur',
          },
        ],
        deAttributeTypeNameEn: [
          {
            required: true,
            message: this.$l('form_rule_message_name_en') || '请输入英文名称',
            trigger: 'blur',
          },
          {
            max: 100,
            message:
              this.$l('form_rule_input_length_100') || '长度在100个字符以内',
            trigger: 'blur',
          },
        ],
      }
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.deAttributeTypeCode) return

      this.$api
        .detailDesignElementsDictionaryTypeApi({
          deAttributeTypeCode: this.deAttributeTypeCode
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) {
        return
      }
      this.loadingOpen()
      this.$api
        .saveDesignElementsDictionaryTypeApi(this.formData)
        .then((res) => {
          this.loadingClose()
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || res.msg,
            type: 'success'
          })
          this.$emit('close')
          this.$emit('reload')
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.openQuestion()
    },
    close() {
      this.$emit('close')
    },
    openQuestion() {
      this.$confirm(
        this.$l('INDEX.tips_question_save') || '是否要保存更改',
        this.$l('INDEX.tips_question_title') || '提示信息',
        {
          distinguishCancelAndClose: true,
          confirmButtonText: this.$l('INDEX.btn_save') || '保存',
          cancelButtonText: this.$l('INDEX.btn_no_save') || '不保存'
        }
      )
        .then(() => {
          this.save()
        })
        .catch((action) => {
          if (action === 'cancel') {
            this.close()
          }
        })
    }
  }
}
</script>
